import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CountryAnimation = ({ isVisible, isHovered }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [positions] = useState([
    { top: "top-right", bottom: "bottom-left" },
    { top: "top-left", bottom: "bottom-right" }
  ]);

  const countries = [
    { name: "Dubai", flag: "https://flagcdn.com/w320/ae.png", code: "ae" },
    { name: "Australia", flag: "https://flagcdn.com/w320/au.png", code: "au" },
    { name: "US", flag: "https://flagcdn.com/w320/us.png", code: "us" },
    { name: "Bangkok", flag: "https://flagcdn.com/w320/th.png", code: "th" },
    { name: "Malaysia", flag: "https://flagcdn.com/w320/my.png", code: "my" },
    { name: "Singapore", flag: "https://flagcdn.com/w320/sg.png", code: "sg" }
  ];

  useEffect(() => {
    if (!isVisible || isHovered) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % positions.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [isVisible, isHovered, positions.length]);

  if (!isVisible) return null;

  const currentPositions = positions[currentIndex];
  const topCountry = countries[currentIndex * 2 % countries.length];
  const bottomCountry = countries[(currentIndex * 2 + 1) % countries.length];

  return (
    <>
      <AnimatePresence mode="wait">
        <motion.div
          key={`top-${currentIndex}`}
          className={`country-badge ${currentPositions.top}`}
          initial={{ opacity: 0, y: -50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.8 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <div className="country-content">
            <img 
              src={topCountry.flag} 
              alt={`${topCountry.name} flag`}
              className="country-flag-img"
            />
            <span className="country-name">{topCountry.name}</span>
          </div>
          <div className="underline"></div>
        </motion.div>
      </AnimatePresence>

      <AnimatePresence mode="wait">
        <motion.div
          key={`bottom-${currentIndex}`}
          className={`country-badge ${currentPositions.bottom}`}
          initial={{ opacity: 0, y: 50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -50, scale: 0.8 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <div className="country-content">
            <img 
              src={bottomCountry.flag} 
              alt={`${bottomCountry.name} flag`}
              className="country-flag-img"
            />
            <span className="country-name">{bottomCountry.name}</span>
          </div>
          <div className="underline"></div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default CountryAnimation;